<script>
  import AnchorText from "../components/AnchorText.svelte";

  let caption = "Offset tisak";
  let copy = `Offset tisak imamo u ponudi u suradnji s našim partnerima, jer je i dalje nezamjenjiva tehnika tiskanja kad posao iziskuje veću količinu kvalitetno tiskanog materijala po povoljnim cijenama.`;
</script>

<AnchorText {caption} {copy} />
